const metadata = {
    basicInformation: 'Basic Information',
    category: 'Category',
    categoryRequired: 'Category is required',
    categoriesLoading: 'Loading categories…',
    categoriesLoadFailed: 'Could not load categories. Please retry.',
    categoriesEmpty: 'No categories are configured yet. Choose General to upload.',
    description: 'Description',
    descriptionRequired: 'Description is required',
    descriptionHelp: 'Provide a brief description of the document content',
    department: 'Department',
    none: 'None',
    tags: 'Tags',
    tagsPlaceholder: 'Add tags to improve searchability',
    tagsHelp: 'Select from suggestions or type custom tags',
    addCustomTag: 'Add custom tag',
    add: 'Add',
    classificationSecurity: 'Classification & Security',
    classification: 'Classification',
    public: 'Public',
    publicDesc: 'Can be shared outside the organization',
    internal: 'Internal',
    internalDesc: 'For internal use only',
    confidential: 'Confidential',
    confidentialDesc: 'Restricted access required',
    defaultAccessLevel: 'Default Access Level',
    privateOnly: 'Private (Only me)',
    teamDepartment: 'Team (My department)',
    organizationEveryone: 'Organization (Everyone)',
    allowShare: 'Allow others to share this document',
    allowDownload: 'Allow others to download this document',
    continueToUpload: 'Continue to Upload',
    metadataNote: 'This metadata will be applied to all {{count}} selected {{files}}.',
    file: 'file',
    files: 'files',
    // #1223 PR 2: the AI suggestion run's state and its retry. The review UI renders these.
    taxonomy: {
      panelTitle: 'Metadata classification',
      panelDescription: 'Review the AI\'s suggestions and confirm or reject them. Only a person can confirm.',
      loadFailed: 'The classification could not be loaded',
      reviewFailed: 'The classification could not be updated',
      empty: 'This document has no classification yet',
      facet: {
        source_scope: 'Scope',
        domain: 'Domain',
        document_type: 'Document type',
        authority: 'Authority',
        product: 'Product',
        project: 'Project',
        customer: 'Customer',
      },
      section: {
        confirmed: 'Confirmed',
        migrated: 'Migrated',
        suggested: 'AI suggestions',
      },
      action: {
        confirm: 'Confirm',
        reject: 'Reject',
        confirming: 'Confirming…',
        rejecting: 'Rejecting…',
        confirmTerm: 'Confirm {{name}}',
        rejectTerm: 'Reject {{name}}',
        confirmingTerm: 'Confirming {{name}}…',
        rejectingTerm: 'Rejecting {{name}}…',
      },
      confidence: '{{percent}}% confidence',
      lowConfidence: 'Low-confidence candidate',
      singleValueHint: 'This field holds one value. To confirm a different candidate, reject the confirmed one first.',
      deprecatedTerm: 'This term has been deprecated',
      aiProvenance: 'AI suggestion / {{version}}',
      unresolvableTerm: 'This term cannot be resolved, so it cannot be acted on',
      reason: {
        filename_signal: 'From the file name',
        heading_signal: 'From a heading',
        body_signal: 'From the body text',
        category_mapping: 'From the existing category',
        default_fallback: 'Default',
      },
      refusal: {
        unknownCode: 'That term is not in this tenant\'s vocabulary',
        deprecatedTerm: 'This term is deprecated and cannot be newly assigned',
        noActiveTaxonomy: 'No active taxonomy, so labels cannot be changed',
        duplicateChange: 'The same term is acted on twice in one review',
        cardinalityViolation: 'This field holds one value. Reject the decided one first',
        migratedNotConfirmable: 'A migrated label cannot be confirmed, only rejected',
        termNoLongerAvailable: 'This term is no longer available',
        notAssigned: 'This label has already been removed',
        confirmNotApplied: 'Someone else confirmed this term first; the current state has been reloaded',
      },
      suggestionRun: {
        notAttempted: 'AI suggestions have not run yet',
        pending: 'AI suggestions are queued',
        running: 'AI suggestions are running',
        succeeded: 'AI suggestions finished',
        succeededNoCandidates: 'AI suggestions finished and found no matching terms',
        failedNotRetryable: 'The AI suggestion could not run, and cannot be retried.',
        failed: 'AI suggestions failed',
        attemptCount: 'Attempts: {{count}}',
        candidateCount: 'Candidates: {{count}}',
      },
      // One string per error_code: each cause implies a different next step,
      // so they must not collapse into one message.
      suggestionError: {
        provider_timeout: 'The AI service timed out. Try again.',
        provider_error: 'The AI service could not be reached. Try again.',
        invalid_output: 'The AI response did not match the required format, so no candidates were saved.',
        no_active_taxonomy: 'No active taxonomy is configured, so AI suggestions cannot run.',
        extraction_unavailable: 'The document text has not been extracted yet. Try again once extraction finishes.',
        extraction_failed: 'Text extraction failed, so no suggestion could run. '
          + 'Re-run extraction, then retry.',
        no_extractable_text: 'No text could be extracted from this document, for example an image-only PDF. Retrying helps only once a version with readable text has been uploaded.',
        superseded_version: 'A newer version replaced this one before its suggestions ran, so none were made. Retry to suggest from the current version.',
        internal_error: 'An internal error stopped the candidates being saved. Try again.',
      },
      retry: {
        failed: 'The AI suggestion retry failed',
        action: 'Retry AI suggestions',
        retrying: 'Retrying…',
        started: 'A new AI suggestion attempt has started',
        alreadySucceeded: 'AI suggestions have already completed for this document',
        runInProgress: 'AI suggestions are already running',
        forbidden: 'You do not have permission to edit this document\'s labels',
      },
    },
  };

export default metadata;
